import constant from "../../../../../constants/constant";
import { AddInvoiceData, InvoicePayload, ProductData } from "../interface";

interface AddInvoicePayloadProps {
    productData: ProductData[];
    invoiceData: AddInvoiceData;
}

export const usePreparePayload = () => {
    const addInvoicePayload = ({
        productData,
        invoiceData,
      }: AddInvoicePayloadProps): InvoicePayload => {
        const isGstApply:boolean =  invoiceData?.supplier_id?.gst_type === constant.GST_TYPE[0].value;
        const total_amount = productData.reduce(
          (sum, product) => sum + (isGstApply ? (product.additional_keys?.grand_total_amount ?? 0) : (product.additional_keys?.grand_total_amount - product.additional_keys?.gst_amount)),
          0
        );
      
        const total_gst = productData.reduce(
          (sum, product) => sum + (product.additional_keys?.gst_amount ?? 0),
          0
        );
      
        const total_product_case = productData.reduce(
          (sum, product) => sum + (product.additional_keys?.qty ?? 0),
          0
        );
      
        return {
          actual_invoice: invoiceData.actual_invoice,
          attachments: invoiceData.attachments ?? [],
          category: Number(invoiceData.category?.value ?? 0),
          invoice_id: invoiceData.invoice_id,
          product_details: productData.map((product) => ({
            cost_amount: (product.additional_keys?.cost_amount - product?.additional_keys?.discount_amount).toFixed(2),
            gst_amount:invoiceData?.supplier_id?.gst_type === constant.GST_TYPE[0].value ? product?.additional_keys?.gst_amount?.toFixed(2) : '0',
            product_id: product.id,
            quantity: Number(product.additional_keys?.qty),
            srp_amount: product.srp_amount,
            product_type_gst_percentage: Number(product?.product_type?.gst_percentage),
            discount_percent:product?.additional_keys?.discount_percentage
          })),
          remark: invoiceData.remark,
          store_id: invoiceData.store_id?.value ?? "",
          supplier_id: invoiceData.supplier_id?.value ?? "",
          supplier_invoice_date: invoiceData.supplier_invoice_date,
          supplier_invoice_number: invoiceData.supplier_invoice_number,
          total_amount: parseFloat(total_amount.toFixed(2)),
          total_gst:invoiceData?.supplier_id?.gst_type === constant.GST_TYPE[0].value ? parseFloat(total_gst.toFixed(2)) : 0,
          total_product_case,
        };
      };
      
    return {
        addInvoicePayload,
    };
};
